"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connection = void 0;
var foundation_1 = require("@deqo/foundation");
var msgpack_1 = require("@msgpack/msgpack");
var KeyedSet_1 = require("../KeyedSet");
var EventSourceBase_1 = require("../streaming/EventSourceBase");
var Codes_1 = require("./Codes");
var PodAdapter_1 = require("./PodAdapter");
var logger = foundation_1.Logger.get('podopolis.connection');
/**
 * Represents a socket connection to a Podopolis server.
 */
var Connection = /** @class */ (function (_super) {
    __extends(Connection, _super);
    /**
     * Initializes a new instance of Connection.
     *
     * @param host The host connection string.
     * @param token The identity token to authenticate with.
     */
    function Connection(host, token) {
        var _this = _super.call(this) || this;
        _this.host = host;
        _this.token = token;
        _this.$state = 'waiting';
        _this.pods = new KeyedSet_1.KeyedSet(function (x) { return x.id; });
        _this.handlers = [];
        _this.lastPingId = 0;
        _this.lastWindowAt = -100;
        _this.nextWindowId = false;
        _this.onUnexpectedClose = function () { return _this.destroyInternal('dropped'); };
        _this.dispatchWindow = function () {
            _this.send(_this.pods.reduce(function (t, p) { return t.concat(p.pull()); }, []));
            _this.nextWindowId = false;
            _this.lastWindowAt = performance.now();
        };
        return _this;
    }
    Object.defineProperty(Connection.prototype, "state", {
        /**
         * Gets the current connection state.
         */
        get: function () {
            return this.$state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Connection.prototype, "clientId", {
        /**
         * The client id assigned to this connection.
         */
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Opens the connection to the server and performs the authentication handshake.
     */
    Connection.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState('connecting');
                        return [4 /*yield*/, this.connect()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.authenticate()];
                    case 2:
                        _a.sent();
                        this.setState('active');
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Joins the current connection to the pod with the specified id.  An instance of Pod will be returned through which all interaction
     * with the pod session will flow.
     *
     * @param podId The id of the pod to join.
     * @param permitToken The permitToken granting access to the pod.
     */
    Connection.prototype.join = function (podId, permitToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('Joining ', podId);
                        this.send([[podId, 210, { token: permitToken }, null]]);
                        return [4 /*yield*/, this.waitFor(function (m) { return m[1] === 101 && m[3] === "join/".concat(podId); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.allocatePod(podId)];
                }
            });
        });
    };
    Connection.prototype.ping = function () {
        if (this.state !== 'active')
            return -1;
        var id = this.lastPingId++;
        this.ws.send("PING:".concat(id));
        return id;
    };
    Connection.prototype.destroy = function (reason) {
        if (reason === void 0) { reason = 'closed'; }
        if (this.destroyed())
            return;
        this.destroyInternal(reason);
    };
    Connection.prototype.setState = function (value) {
        this.$state = value;
        this.emit('state', value);
    };
    Connection.prototype.connect = function () {
        var _this = this;
        return new Promise(function (rs, rj) {
            try {
                var ws_1 = _this.ws = new WebSocket(_this.host);
                ws_1.binaryType = 'arraybuffer';
                ws_1.onopen = function () {
                    ws_1.onclose = _this.onUnexpectedClose;
                    rs(null);
                };
                ws_1.onclose = function (e) { return rj(new Error(e.reason)); };
                ws_1.onmessage = function (e) {
                    if (e.data instanceof ArrayBuffer)
                        _this.receive(e.data);
                    if (typeof (e.data) === 'string' && e.data.startsWith('PONG')) {
                        _this.emit('pong', parseInt(e.data.substr(5), 10));
                    }
                };
            }
            catch (e) {
                rj(e);
            }
        });
    };
    Connection.prototype.authenticate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Authenticate by sending a 100 (authenticate) with the identity token.  If the authentication fails the connection will be ???
                        logger.log('Authenticating');
                        this.send([['~', 100, { token: this.token }, null]]);
                        return [4 /*yield*/, this.waitFor(function (m) { return m[1] === 101; })];
                    case 1:
                        reply = _a.sent();
                        this.id = reply[2].clientId;
                        return [2 /*return*/];
                }
            });
        });
    };
    Connection.prototype.destroyInternal = function (reason) {
        this.setState('closed');
        _super.prototype.destroy.call(this);
        if (this.ws) {
            this.ws.onmessage = null;
            this.ws.onclose = null;
            this.ws.close();
        }
        this.pods.forEach(function (x) { return x.destroy(reason); });
        this.pods.clear();
    };
    Connection.prototype.requestWindow = function () {
        // If not, how long since the last window?
        var tslw = performance.now() - this.lastWindowAt;
        // If longer than the window interval, dispatch immediately
        if (tslw > Connection.windowSize) {
            this.dispatchWindow();
        }
        // Otherwise, if not scheduled, schedule for the difference
        else if (this.nextWindowId === false) {
            this.nextWindowId = setTimeout(this.dispatchWindow, Connection.windowSize - tslw);
        }
    };
    Connection.prototype.send = function (batch) {
        if (logger.enabled) {
            batch.forEach(function (x) { return logger.log('Out:', msgStr(x)); });
        }
        if (this.ws.readyState === WebSocket.OPEN) {
            this.ws.send((0, msgpack_1.encode)(batch));
        }
    };
    Connection.prototype.receive = function (rawBatch) {
        var e_1, _a;
        try {
            for (var _b = __values((0, msgpack_1.decode)(rawBatch)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var msg = _c.value;
                if (logger.enabled) {
                    logger.log('In:', msgStr(msg));
                }
                var pod = this.pods.get(msg[0]);
                if (pod) {
                    pod.push(msg);
                }
                else {
                    this.handle(msg);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Connection.prototype.handle = function (msg) {
        var e_2, _a;
        try {
            for (var _b = __values(this.handlers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var h = _c.value;
                if (h(msg)) {
                    var ri = this.handlers.indexOf(h);
                    this.handlers.splice(ri, 1);
                    return;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Connection.prototype.waitFor = function (predicate) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // TODO: timeout?
                return [2 /*return*/, new Promise(function (rs) {
                        _this.handlers.push(function (msg) {
                            if (predicate(msg)) {
                                rs(msg);
                                return true;
                            }
                            return false;
                        });
                    })];
            });
        });
    };
    Connection.prototype.allocatePod = function (podId) {
        var pod = new PodAdapter_1.PodAdapter(podId, this.id, this.createBridge(podId));
        this.pods.add(pod);
        return pod;
    };
    Connection.prototype.createBridge = function (podId) {
        var _this = this;
        return {
            requestPull: function () { return _this.requestWindow(); },
            requestDestroy: function () {
                if (_this.destroyed())
                    return;
                var pod = _this.pods.get(podId);
                if (!pod)
                    return;
                _this.pods.delete(podId);
                // eslint-disable-next-line
                try {
                    pod === null || pod === void 0 ? void 0 : pod.destroy('closed');
                    _this.send([[podId, Codes_1.Codes.leave, {}, null]]);
                }
                catch (_a) {
                    // Ignore
                }
            },
        };
    };
    Connection.windowSize = 70;
    return Connection;
}(EventSourceBase_1.EventSourceBase));
exports.Connection = Connection;
var msgStr = function (m) { return JSON.stringify(m).slice(0, 1024); };
